'use client';

import { ReactNode } from 'react';

import { useRouter } from 'next/navigation';

import Button from '@/components/FormFields/Button';
import cn from '@/helpers/utils/classNames';

interface NotFoundButtonProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

const NotFoundButton = ({ children, className, onClick }: NotFoundButtonProps) => {
  const router = useRouter();

  return (
    <Button
      type="button"
      variant="filled"
      className={cn('', className)}
      scheme="primary"
      onClick={onClick ? onClick : () => router.back()}
    >
      {children}
    </Button>
  );
};

export default NotFoundButton;
